import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe, CurrencyPipe, DecimalPipe } from '@angular/common';

@Pipe({
  name: 'dynamicPipe',
})
export class DynamicPipe implements PipeTransform {
  constructor(
    private datePipe: DatePipe,
    private currencyPipe: CurrencyPipe,
    private decimalPipe: DecimalPipe,
  ) {}

  /** CurrencyPipe rejeita "1500,75"; converte a vírgula decimal quando o texto é só um número. */
  private normalizeDecimalComma(value: any): any {
    return typeof value === 'string' && /^\s*-?\d+,\d+\s*$/.test(value)
      ? value.trim().replace(',', '.')
      : value;
  }

  transform(value: any, pipeToken: string, pipeArgs?: any): any {
    if (value === null || value === undefined || value === '') {
      return '';
    }

    switch (pipeToken) {
      case 'datetime':
        return this.datePipe.transform(value, pipeArgs || 'dd/MM/yyyy - HH:mm');

      case 'date':
        return this.datePipe.transform(value, pipeArgs || 'dd/MM/yyyy');

      case 'currency':
        return this.currencyPipe.transform(
          this.normalizeDecimalComma(value),
          pipeArgs || 'BRL',
          'symbol',
          '1.2-2',
        );

      case 'decimal':
        return this.decimalPipe.transform(value, pipeArgs || '1.2-2');

      default:
        return value;
    }
  }
}
